
import PlaySound from "./play_sound";
import { mouseEvent } from "../common/mouse_event";
import SentenceGroup from "./sentence_group";
import SentenceFollowGroup from "./sentence_follow_group";
import { PLAYER_TYPE } from './player_type';
export default class ReadSentence extends PlaySound {
    isShow = false; //因先播放音檔再顯示逐句朗讀，所以不可用是否播放判定，需另外判定
    constructor(el, target) {
        super(el, target);
        this.targetGroup = el.targetGroup;
        this.readType = el.readType;

        this.audio = window.soundManager.soundPlayer;
        this.playerType = PLAYER_TYPE.FULL;
    }

    init() {
        mouseEvent.add_mouse_event(this);
    }

    trigger() {
        super.trigger();
        // console.log('do something(read sentence)');
        // console.log("this", this);
        if (this.isShow) return;

        for (let i = 0; i < this.itemControl.bookItems.length; i++) {
            if (this.itemControl.bookItems[i].target.name == this.targetGroup) {
                // console.log(window.bookItems[i].target.name);
                // console.log(this.targetGroup);
                // console.log(window.bookItems[i]);

                // TODO : 減少迴圈效能
                switch (this.readType) {
                    case "朗讀":
                        if (this.itemControl.bookItems[i] instanceof SentenceGroup) {
                            this.itemControl.bookItems[i].trigger(this.audio);
                            this.isShow = true;
                        }
                        break;
                    case "跟讀":
                        if (this.itemControl.bookItems[i] instanceof SentenceFollowGroup) {
                            this.itemControl.bookItems[i].trigger(this.audio);
                            this.isShow = true;
                        }
                        break;
                }
            }
        }

        if (this.isShow) {
            window.soundManager.setCallBackFunc(function () {
                this.isShow = false;
            }.bind(this));
        }
    }
}